import { useGuideStore } from '../../stores/guideStore';
import { FigmaWidget as TFigmaWidget } from '../../types';
import styled from 'styled-components';
import { useActiveWidget } from '../../queries/guides';
import { EmptyWidget } from './EmptyWidget';
import { IconFigma } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { useInspectorStore } from '../../stores/inspectorStore';
import { InspectorSetting } from '../../constants/guides';
import { CSS_PROPERTIES } from '../guides/Inspector/constants';
import { toPx, useWidgetStyleProperty } from '../guides/Inspector/helpers';

interface Props {
  widget: TFigmaWidget;
}

const FigmaWidget = ({ widget }: Props) => {
  const { translate } = useTranslate();
  const isEmpty = widget.sourceId === '';
  const isEditMode = useGuideStore(s => s.isEditMode);
  const activeWidget = useActiveWidget();
  const isActiveWidget = widget.id === activeWidget?.id;
  const activeInspectorSetting = useInspectorStore(
    s => s.activeInspectorSetting,
  );
  const { value: borderRadius } = useWidgetStyleProperty(
    widget?.style?.stylesheet,
    'widgets.media.borderRadius',
    CSS_PROPERTIES.BORDER_RADIUS,
  );

  const isWidgetActive =
    isActiveWidget && activeInspectorSetting === InspectorSetting.WIDGET_VIEW;

  const renderFigmaWidget = () => {
    if (isEmpty) {
      if (isEditMode) {
        return (
          <EmptyWidget
            icon={<IconFigma />}
            text={translate('WIDGETS_CONSTANTS.EMPTY_WIDGETS.FIGMA')}
          />
        );
      }
      return null;
    }

    return (
      <>
        {isEditMode && !isWidgetActive && <SelectionOverlay />}
        <EmbedContainer $borderRadius={borderRadius}>
          <Iframe
            src={`https://embed.figma.com/${widget.sourceId}?embed-host=bynder.com&theme=${widget.settings.theme ? widget.settings.theme : 'light'}&footer=${widget.settings.footer ? 'true' : 'false'}&viewport-controls=${widget.settings.controls ? 'true' : 'false'}`}
          />
        </EmbedContainer>
      </>
    );
  };

  return (
    <StyledFigmaWidgetContainer>
      {renderFigmaWidget()}
    </StyledFigmaWidgetContainer>
  );
};

export default FigmaWidget;

const StyledFigmaWidgetContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const EmbedContainer = styled.div<{ $borderRadius: string }>`
  border-radius: ${({ $borderRadius }) => toPx($borderRadius)};
  overflow: hidden;
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  /* 16:9 */
  padding-top: 25px;
  height: 0;
`;

const Iframe = styled.iframe`
  position: absolute;
  border: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const SelectionOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  opacity: 0.5;
  z-index: 1;
`;
